// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { VOLOP_IMPORTED_TYPE_MAP } from './volopImportedTypeMap';

export const VOLOP_SOURCES = {
  ...VOLOP_IMPORTED_TYPE_MAP,
  IDEALIST: 'Idealist',
};
